import React from "react";
import BsModal from "../../Misc/BsModal";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import Datetime from "react-datetime";
import SuperSelect from "../../Misc/SuperSelect";
import DtPicker from "../../Misc/DtPicker";

export default class WorkdocRolesModal extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      data: {},
    };
  }
  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sourceRole !== this.props.sourceRole) {
      this.load();
    }
  }

  load = async () => {
    let sourceRole = this.props.sourceRole || {};
    this.setState({
      extended: false,
      data: { ...sourceRole },
    });
  };

  delete = async () => {
    let data = this.state.data;
    this.setState({ pending: true, redirect: false });
    let result = await this.context.api.q(`/participant/delete`, {
      id: data.id,
    });
    if (result !== false) {
      this.props.onAfterRoleSave();
    } else {
      this.context.toast("Не удалось удалить участника", "error");
      this.setState({ pending: false });
    }
  };

  save = async () => {
    let data = this.state.data;
    let dateto = data.dateto || this.context.api.minDate;

    const reset = data.id ? this.context.api.nullUuid : null;

    let saveData = {
      id: data.id || null,
      document: this.props.item.id,
      activity: data.activity || null,
      member: data.staff || reset,
      position: data.position || reset,
      structure: data.structure || reset,
      state: data.state || null,
      dateto: data.id ? dateto : null,
      number: data.number || 0,
      sequence: data.sequence || 0,
      groupid: data.groupid || 0,
    };

    this.setState({ pending: true });
    let result = await this.context.api.q("/participant/set", saveData);
    this.setState({ pending: false });
    if (result !== false) {
      this.props.onAfterRoleSave();
    } else {
      this.context.toast("Не удалось добавить участника", "error");
    }
  };

  onChange = (id, value) => {
    this.setState((state) => {
      let { data } = state;
      data[id] = value;
      return { data };
    });
  };

  dateTimeChange = (key, value) => {
    if (value instanceof Object) {
      this.setState((state) => {
        let data = state.data;
        data[key] = value.toDate();
        return { data };
      });
    }
  };

  toggleExtended = (extended = true) => {
    this.setState({ extended });
  };

  render() {
    const { data } = this.state;
    return (
      <>
        <BsModal center xl onHide={this.props.onHide} show={true}>
          <Blocker on={this.state.pending}>
            <div className="mb-5 pb-3   modal-title w-100 h4 d-flex justify-content-between">
              <span> {data.id ? "Изменить" : "Добавить"} участника </span>
            </div>

            <div>
              <div className="row">
                <div className="col-lg border-right">
                  <div className="form-group  ">
                    <div className="font-weight-bolder mb-4">
                      На каком этапе делает:
                    </div>
                    <SuperSelect
                      light
                      cache
                      defaultValue={data.state}
                      onChange={(value) => this.onChange("state", value)}
                      anyState
                      forcePath="/state/by/type"
                      forceQueryParams={{ type: this.props.item.type }}
                      placeholder="Статус ..."
                      nameField="label"
                      idField="id"
                    />
                  </div>
                </div>
                <div className="col-lg border-right">
                  <div className="form-group">
                    <div className="font-weight-bolder mb-4"> Кто делает: </div>
                    <div className="mb-1">
                      <SuperSelect
                        cache
                        light
                        isClearable
                        defaultValue={data.structure}
                        onChange={(value) => this.onChange("structure", value)}
                        essence="structure"
                        placeholder="Отдел ..."
                        nameField="label"
                        idField="id"
                        type="soc.structure"
                      />
                    </div>
                    <div className="mb-1">
                      <SuperSelect
                        cache
                        light
                        isClearable
                        defaultValue={data.position}
                        onChange={(value) => this.onChange("position", value)}
                        essence="position"
                        placeholder="Должность ..."
                        nameField="label"
                        idField="id"
                      />
                    </div>
                    <div className="mb-1">
                      <SuperSelect
                        cache
                        light
                        isClearable
                        defaultValue={data.member}
                        onChange={(value) => this.onChange("staff", value)}
                        essence="staff"
                        placeholder="Конкретный сотрудник ..."
                        nameField="label"
                        idField="id"
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <div className="font-weight-bolder mb-4">Что делает: </div>
                    <SuperSelect
                      light
                      cache
                      defaultValue={data.activity}
                      onChange={(value) => this.onChange("activity", value)}
                      essence="activity"
                      placeholder="Действие ..."
                      nameField="name"
                      idField="id"
                    />
                  </div>
                </div>
              </div>

              <div className="text-right mb-5">
                <span
                  className="text-primary cursor-pointer"
                  onClick={() => this.toggleExtended(!this.state.extended)}
                >
                  Дополнительно
                  {!this.state.extended ? (
                    <i className="fa fa-chevron-down ml-2"></i>
                  ) : (
                    <i className="fa fa-chevron-up  ml-2"></i>
                  )}
                </span>
              </div>

              {this.state.extended && (
                <>
                  <div className="row">
                    <div className="form-group col">
                      <label>Срок до:</label>
                      <DtPicker
                        isClearable
                        time
                        value={data.dateto}
                        onChange={(v) => this.onChange("dateto", v)}
                      />
                    </div>
                    <div className="form-group col">
                      <label>Идентификатор группы:</label>
                      <input
                        className="form-control"
                        type="number"
                        value={data.groupid || ""}
                        onChange={(e) =>
                          this.onChange("groupid", e.target.value)
                        }
                      />
                    </div>

                    <div className="form-group col">
                      <label>Необходимое число участников:</label>
                      <input
                        className="form-control"
                        type="number"
                        value={data.number || ""}
                        onChange={(e) =>
                          this.onChange("number", e.target.value)
                        }
                      />
                    </div>

                    <div className="form-group col">
                      <label>Порядок:</label>
                      <input
                        className="form-control"
                        type="number"
                        value={data.sequence || ""}
                        onChange={(e) =>
                          this.onChange("sequence", e.target.value)
                        }
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div>
              <div className="w-100 d-flex justify-content-between align-items-center">
                <div>
                  {data.id && (
                    <button className="btn btn-danger" onClick={this.delete}>
                      Удалить
                    </button>
                  )}
                </div>
                <div>
                  <button className="btn btn-primary mr-2" onClick={this.save}>
                    Сохранить
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={this.props.onHide}
                  >
                    Отмена
                  </button>
                </div>
              </div>
            </div>
          </Blocker>
        </BsModal>
      </>
    );
  }
}
